// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';

import common from './routes/common';
import home from './routes/home';
import templateGoverningAuthority from './routes/templateGoverningAuthority';


// import then needed Font Awesome functionality
import { library, dom } from '@fortawesome/fontawesome-svg-core';
// import the Facebook and Twitter icons
import { faFacebookSquare, faTwitterSquare, faLinkedin, faYoutubeSquare, faInstagramSquare } from '@fortawesome/free-brands-svg-icons';
import { faTimes, faSearch, faChevronLeft, faChevronRight, faQuoteLeft, faQuoteRight } from '@fortawesome/free-solid-svg-icons';

// add the imported icons to the library
library.add(faTimes, faChevronLeft, faChevronRight, faFacebookSquare, faTwitterSquare, faLinkedin, faYoutubeSquare, faInstagramSquare, faQuoteLeft, faQuoteRight, faSearch );

// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
dom.watch();

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  templateGoverningAuthority,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js